import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { CreateUser } from './pages/CreateUser';
import { EvokChat } from './pages/EvokChat';
import { Login } from './pages/Login';
import { ForgetPassword } from './pages/ForgetPassword';
import { Profile } from './pages/Profile';
import { TermsOfServices } from './pages/terms/TermsOfServices';
import { PrivacyPolicies } from './pages/terms/PrivacyPolicies';
import { Questionary } from './pages/Questionary';
import { QuestionaryAlert } from './pages/QuestionaryAlert';
import { AdminTemplate } from './pages/admin/AdminTemplate';
import { Plans } from './pages/Plans';
import { ResultQuestionary } from './pages/ResultQuestionary';
import { ProfileAdmin } from './pages/admin/ProfileAdmin';
import { UserManagement } from './pages/admin/UserManagement';
import { Dashboard } from './pages/admin/Dashboard';
import { AdminBILicenses } from './pages/adminBI/AdminBILicenses';
import { AdminInvitationsManager } from './pages/admin/AdminInvitationsManager';
import { AdminEnterprise } from './pages/admin/AdminEnterprise';
import { ChangePassword } from './pages/ChangePassword';
import { ChartTest } from './pages/ChartTest';

function Routing() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgetPassword" element={<ForgetPassword />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/createUser" element={<CreateUser />} />
        <Route path="/evokChat" element={<EvokChat />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/termsOfServices" element={<TermsOfServices />} />
        <Route path="/privacyPolicies" element={<PrivacyPolicies />} />
        <Route path="/questionary" element={<Questionary />} />
        <Route path="/questionaryAlert" element={<QuestionaryAlert />} />
        <Route path="/resultQuestionary" element={<ResultQuestionary />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/upgradePlan" element={<Plans />} /> {/* Por enquanto vai para a tela de planos*/}

        <Route path="/admin/painel" element={<AdminTemplate />} />
        <Route path="/admin/profile" element={<ProfileAdmin />} />
        <Route path="/admin/userManagement/:userId" element={<UserManagement />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/invitationsManager" element={<AdminInvitationsManager />} />
        {/*<Route path="/adminBI/licenses" element={<AdminBILicenses />} />*/}
        <Route path="/admin/enterprises" element={<AdminEnterprise />} />

        {/* <Route path="/chartTest" element={<ChartTest />} /> */}
      </Routes>
    </HashRouter>
  );
}

export default Routing;
